// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================
=         Design System Color Palette         =
============================================= */
.styles_color__NDrnl.styles_ocean-50__fVeRP {
  color: #e6f2ff;
}

.styles_color__NDrnl.styles_ocean-100__7ptY2 {
  color: #e6f2ff;
}

.styles_color__NDrnl.styles_ocean-200__CvGIA {
  color: #b3daff;
}

.styles_color__NDrnl.styles_ocean-300__RJTNy {
  color: #7abfff;
}

.styles_color__NDrnl.styles_ocean-400__DrDHl {
  color: #2392fb;
}

.styles_color__NDrnl.styles_ocean-500__vCbJA {
  color: #0074e0;
}

.styles_color__NDrnl.styles_ocean-600__K3Csw {
  color: #043571;
}

.styles_color__NDrnl.styles_space-50__9KCPU {
  color: #f0f0f0;
}

.styles_color__NDrnl.styles_space-100__fnsmM {
  color: #e3e3e3;
}

.styles_color__NDrnl.styles_space-200__PKs9S {
  color: #bfbfbf;
}

.styles_color__NDrnl.styles_space-300__apiz8 {
  color: gray;
}

.styles_color__NDrnl.styles_space-400__oghQZ {
  color: #616161;
}

.styles_color__NDrnl.styles_space-500__\\+uZ6a {
  color: #283439;
}

.styles_color__NDrnl.styles_gray-50__zctAd {
  color: #eff3f6;
}

.styles_color__NDrnl.styles_gray-100__1Vqwi {
  color: #e6ecef;
}

.styles_color__NDrnl.styles_gray-200__miF3H {
  color: #cfd8de;
}

.styles_color__NDrnl.styles_gray-300__hf2jp {
  color: #a8b9c2;
}

.styles_color__NDrnl.styles_gray-400__Kg-sU {
  color: #7e98a5;
}

.styles_color__NDrnl.styles_gray-500__bKYAB {
  color: #738f9c;
}

.styles_color__NDrnl.styles_green-50__PbdvO {
  color: #e3fdf6;
}

.styles_color__NDrnl.styles_green-100__t-dAd {
  color: #c5f6ea;
}

.styles_color__NDrnl.styles_green-200__mvgEF {
  color: #69ddc2;
}

.styles_color__NDrnl.styles_green-300__rgOnY {
  color: #45bfa3;
}

.styles_color__NDrnl.styles_green-400__pzhkz {
  color: #1cab8a;
}

.styles_color__NDrnl.styles_green-500__Brmx2 {
  color: #128268;
}

.styles_color__NDrnl.styles_red-50__anrfa {
  color: #fff0f3;
}

.styles_color__NDrnl.styles_red-100__7EjQ3 {
  color: #f9d2db;
}

.styles_color__NDrnl.styles_red-200__zXPi\\+ {
  color: #f8b4c4;
}

.styles_color__NDrnl.styles_red-300__7GoGK {
  color: #e85e81;
}

.styles_color__NDrnl.styles_red-400__eVJLU {
  color: #e23661;
}

.styles_color__NDrnl.styles_red-500__uwUqn {
  color: #b82348;
}

.styles_color__NDrnl.styles_yellow-50__HoJL9 {
  color: #fffae6;
}

.styles_color__NDrnl.styles_yellow-100__v-IxQ {
  color: #fff0b3;
}

.styles_color__NDrnl.styles_yellow-200__2858K {
  color: #ffe380;
}

.styles_color__NDrnl.styles_yellow-300__xc6mZ {
  color: #ffcf57;
}

.styles_color__NDrnl.styles_yellow-400__B1uhj {
  color: #ffc60a;
}

.styles_color__NDrnl.styles_yellow-500__5pXfh {
  color: #ffb700;
}

.styles_color__NDrnl.styles_orange-50__x-RWl {
  color: #fff2eb;
}

.styles_color__NDrnl.styles_orange-100__NHEcl {
  color: #ffe4d6;
}

.styles_color__NDrnl.styles_orange-200__20EDO {
  color: #ffc69e;
}

.styles_color__NDrnl.styles_orange-300__f021S {
  color: #ffa047;
}

.styles_color__NDrnl.styles_orange-400__rdRoP {
  color: #ff7b42;
}

.styles_color__NDrnl.styles_orange-500__Gu7uF {
  color: #ee4920;
}

.styles_color__NDrnl.styles_turquoise-50__9-hYi {
  color: transparent;
}

.styles_color__NDrnl.styles_turquoise-100__cjBVj {
  color: #e6fcff;
}

.styles_color__NDrnl.styles_turquoise-200__UsPQB {
  color: #b3f5ff;
}

.styles_color__NDrnl.styles_turquoise-300__uNSHw {
  color: #78e2f2;
}

.styles_color__NDrnl.styles_turquoise-400__Za-DF {
  color: #00c7e6;
}

.styles_color__NDrnl.styles_turquoise-500__m6hS4 {
  color: transparent;
}

.styles_color__NDrnl.styles_turquoise-600__QF9KC {
  color: transparent;
}

.styles_color__NDrnl.styles_violet-50__pS2AL {
  color: #eae6ff;
}

.styles_color__NDrnl.styles_violet-100__97WEC {
  color: #d9d1ff;
}

.styles_color__NDrnl.styles_violet-200__crIE7 {
  color: #bfb3ff;
}

.styles_color__NDrnl.styles_violet-300__jvZfh {
  color: #9d90ea;
}

.styles_color__NDrnl.styles_violet-400__p5UaC {
  color: #8678d9;
}

.styles_color__NDrnl.styles_violet-500__-UPUY {
  color: #6f5ccc;
}

.styles_color__NDrnl.styles_snow-50__l8yqv {
  color: white;
}

.styles_color__NDrnl.styles_snow-100__lsgow {
  color: #f7f7f7;
}

.styles_color__NDrnl.styles_snow-200__o-TXD {
  color: #f0efef;
}

.styles_color__NDrnl.styles_snow-300__EYSmK {
  color: #e6e6e6;
}

.styles_color__NDrnl.styles_snow-400__qUCoZ {
  color: #e1e0e0;
}

.styles_color__NDrnl.styles_snow-500__CocaK {
  color: #cfcfcf;
}

/* =============================================
=              Background Colors              =
============================================= */
.styles_background-color__xUwvO.styles_ocean__UnyKs {
  background-color: #2392fb;
  color: white;
}

.styles_background-color__xUwvO.styles_ocean-light__dG3A0 {
  background-color: #b3daff;
  color: white;
}

.styles_background-color__xUwvO.styles_green__poa1q {
  background-color: #1cab8a;
  color: white;
}

.styles_background-color__xUwvO.styles_green-light__EXG1o {
  background-color: #69ddc2;
  color: white;
}

.styles_background-color__xUwvO.styles_red__3swe9 {
  background-color: #e23661;
  color: white;
}

.styles_background-color__xUwvO.styles_red-light__iImC2 {
  background-color: #f8b4c4;
  color: white;
}

.styles_background-color__xUwvO.styles_orange__fpJEP {
  background-color: #ff7b42;
  color: white;
}

.styles_background-color__xUwvO.styles_orange-light__pGJGr {
  background-color: #ffc69e;
  color: white;
}

.styles_background-color__xUwvO.styles_space__QesRK {
  background-color: #616161;
  color: white;
}

.styles_background-color__xUwvO.styles_space-light__c6PhC {
  background-color: #bfbfbf;
  color: #616161;
}

.styles_background-color__xUwvO.styles_gray-light__wOWSp {
  background-color: #f0efef;
  color: #616161;
}

.styles_background-color__xUwvO.styles_violet__Z2O65 {
  background-color: #8678d9;
  color: white;
}

.styles_background-color__xUwvO.styles_violet-light__qAXPM {
  background-color: #bfb3ff;
  color: #616161;
}

.styles_background-color__xUwvO.styles_yellow__KszBO {
  background-color: #ffc60a;
  color: white;
}

.styles_background-color__xUwvO.styles_yellow-light__VA5Gv {
  background-color: #ffe380;
  color: #616161;
}

/* The "blur" parameter (the third one) for drop shadow is rendered twice as in the box shadow.
 * So we have to divide it by 2 to have the same output as box shadows.
*/
.styles_root__FKzae.styles_bottomMargin__CkW7J {
  margin-bottom: 4px ;
}
.styles_root__FKzae .styles_label__jX2Uh {
  font-weight: 500;
  font-size: 1rem;
  letter-spacing: -0.09px;
  line-height: 20px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
  color: #616161;
}
.styles_root__FKzae.styles_groupLabel__CGHks .styles_label__jX2Uh {
  font-weight: 700;
  font-size: 0.8571428571rem;
  letter-spacing: 0.01px;
  line-height: 18px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
  color: #7e98a5;
}
.styles_root__FKzae .styles_requiredIndicator__XY0jM {
  font-weight: 700;
  font-size: 0.8571428571rem;
  letter-spacing: 0.01px;
  line-height: 18px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
  color: #b82348;
  margin-left: 2px ;
}
.styles_root__FKzae .styles_labelHelperTextIcon__JYkff {
  margin-left: 2px ;
}
.styles_root__FKzae .styles_labelWarningIcon__LmhD8 {
  margin-left: 2px ;
}
.styles_root__FKzae .styles_tooltipTrigger__VPA6I {
  align-items: center;
  display: inline-flex;
}
.styles_root__FKzae.styles_disabled__xq3MG .styles_label__jX2Uh,
.styles_root__FKzae.styles_disabled__xq3MG .styles_requiredIndicator__XY0jM {
  color: #bfbfbf;
}`, "",{"version":3,"sources":["webpack://./src/ui-kit/styles/_theme/_colors.scss","webpack://./src/ui-kit/components/label/styles.module.scss","webpack://./src/ui-kit/styles/_theme/_shadows.scss","webpack://./src/ui-kit/styles/_theme/_typography.scss"],"names":[],"mappings":"AAEA;;+CAAA;AAmFI;EACI,cAjFC;ACAT;;ADgFI;EACI,cAjFC;ACIT;;AD4EI;EACI,cAjFC;ACQT;;ADwEI;EACI,cAjFC;ACYT;;ADoEI;EACI,cAjFC;ACgBT;;ADgEI;EACI,cAjFC;ACoBT;;AD4DI;EACI,cAjFC;ACwBT;;ADwDI;EACI,cAjFC;AC4BT;;ADoDI;EACI,cAjFC;ACgCT;;ADgDI;EACI,cAjFC;ACoCT;;AD4CI;EACI,WAjFC;ACwCT;;ADwCI;EACI,cAjFC;AC4CT;;ADoCI;EACI,cAjFC;ACgDT;;ADgCI;EACI,cAjFC;ACoDT;;AD4BI;EACI,cAjFC;ACwDT;;ADwBI;EACI,cAjFC;AC4DT;;ADoBI;EACI,cAjFC;ACgET;;ADgBI;EACI,cAjFC;ACoET;;ADYI;EACI,cAjFC;ACwET;;ADQI;EACI,cAjFC;AC4ET;;ADII;EACI,cAjFC;ACgFT;;ADAI;EACI,cAjFC;ACoFT;;ADJI;EACI,cAjFC;ACwFT;;ADRI;EACI,cAjFC;AC4FT;;ADZI;EACI,cAjFC;ACgGT;;ADhBI;EACI,cAjFC;ACoGT;;ADpBI;EACI,cAjFC;ACwGT;;ADxBI;EACI,cAjFC;AC4GT;;AD5BI;EACI,cAjFC;ACgHT;;ADhCI;EACI,cAjFC;ACoHT;;ADpCI;EACI,cAjFC;ACwHT;;ADxCI;EACI,cAjFC;AC4HT;;AD5CI;EACI,cAjFC;ACgIT;;ADhDI;EACI,cAjFC;ACoIT;;ADpDI;EACI,cAjFC;ACwIT;;ADxDI;EACI,cAjFC;AC4IT;;AD5DI;EACI,cAjFC;ACgJT;;ADhEI;EACI,cAjFC;ACoJT;;ADpEI;EACI,cAjFC;ACwJT;;ADxEI;EACI,cAjFC;AC4JT;;AD5EI;EACI,cAjFC;ACgKT;;ADhFI;EACI,cAjFC;ACoKT;;ADpFI;EACI,cAjFC;ACwKT;;ADxFI;EACI,kBAjFC;AC4KT;;AD5FI;EACI,cAjFC;ACgLT;;ADhGI;EACI,cAjFC;ACoLT;;ADpGI;EACI,cAjFC;ACwLT;;ADxGI;EACI,cAjFC;AC4LT;;AD5GI;EACI,kBAjFC;ACgMT;;ADhHI;EACI,kBAjFC;ACoMT;;ADpHI;EACI,cAjFC;ACwMT;;ADxHI;EACI,cAjFC;AC4MT;;AD5HI;EACI,cAjFC;ACgNT;;ADhII;EACI,cAjFC;ACoNT;;ADpII;EACI,cAjFC;ACwNT;;ADxII;EACI,cAjFC;AC4NT;;AD5II;EACI,YAjFC;ACgOT;;ADhJI;EACI,cAjFC;ACoOT;;ADpJI;EACI,cAjFC;ACwOT;;ADxJI;EACI,cAjFC;AC4OT;;AD5JI;EACI,cAjFC;ACgPT;;ADhKI;EACI,cAjFC;ACoPT;;AD/JA;;+CAAA;AA8EI;EALA,yBAAA;EACA,YAAA;AC6FJ;;ADzFI;EALA,yBAAA;EACA,YAAA;ACkGJ;;AD9FI;EALA,yBAAA;EACA,YAAA;ACuGJ;;ADnGI;EALA,yBAAA;EACA,YAAA;AC4GJ;;ADxGI;EALA,yBAAA;EACA,YAAA;ACiHJ;;AD7GI;EALA,yBAAA;EACA,YAAA;ACsHJ;;ADlHI;EALA,yBAAA;EACA,YAAA;AC2HJ;;ADvHI;EALA,yBAAA;EACA,YAAA;ACgIJ;;AD5HI;EALA,yBAAA;EACA,YAAA;ACqIJ;;ADjII;EALA,yBAAA;EACA,cAAA;AC0IJ;;ADtII;EALA,yBAAA;EACA,cAAA;AC+IJ;;AD3II;EALA,yBAAA;EACA,YAAA;ACoJJ;;ADhJI;EALA,yBAAA;EACA,cAAA;ACyJJ;;ADrJI;EALA,yBAAA;EACA,YAAA;AC8JJ;;AD1JI;EALA,yBAAA;EACA,cAAA;ACmKJ;;ACtTA;;CAAA;ADbI;EACI,mBAAA;AAyUR;AAtUI;EE6CA,gBAAA;EANA,eAAA;EACA,uBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;EFKjB,cAAA;AA2UR;AAxUI;EEuCA,gBAAA;EANA,0BAAA;EACA,sBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;EFWjB,cAAA;AA6UR;AA1UI;EEiCA,gBAAA;EANA,0BAAA;EACA,sBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;EFiBjB,cAAA;EACA,iBAAA;AA+UR;AA5UI;EACI,iBAAA;AA8UR;AA3UI;EACI,iBAAA;AA6UR;AA1UI;EACI,mBAAA;EACA,oBAAA;AA4UR;AAxUQ;;EAEI,cAAA;AA0UZ","sourcesContent":["@use 'sass:map';\n\n/* =============================================\n=         Design System Color Palette         =\n============================================= */\n$colors: (\n    // ocean\n    ocean-50: hsla(210, 100%, 95%, 1),\n    ocean-100: hsla(210, 100%, 95%, 1),\n    ocean-200: hsla(209, 100%, 85%, 1),\n    ocean-300: hsla(209, 100%, 74%, 1),\n    ocean-400: hsla(209, 96%, 56%, 1),\n    ocean-500: hsla(209, 100%, 44%, 1),\n    ocean-600: hsla(213, 93%, 23%, 1),\n    // space\n    space-50: hsla(0, 0%, 94%, 1),\n    space-100: hsla(0, 0%, 89%, 1),\n    space-200: hsla(0, 0%, 75%, 1),\n    space-300: hsla(0, 0%, 50%, 1),\n    space-400: hsla(0, 0%, 38%, 1),\n    space-500: hsla(198, 18%, 19%, 1),\n    // gray\n    gray-50: hsla(200, 27%, 95%, 1),\n    gray-100: hsla(200, 21%, 92%, 1),\n    gray-200: hsla(201, 18%, 84%, 1),\n    gray-300: hsla(201, 18%, 71%, 1),\n    gray-400: hsla(200, 18%, 57%, 1),\n    gray-500: hsl(199, 17%, 53%, 1),\n    // green\n    green-50: hsla(164, 85%, 94%, 1),\n    green-100: hsla(165, 74%, 87%, 1),\n    green-200: hsla(166, 63%, 64%, 1),\n    green-300: hsla(166, 49%, 51%, 1),\n    green-400: hsla(166, 72%, 39%, 1),\n    green-500: hsla(166, 76%, 29%, 1),\n    // red\n    red-50: hsla(346, 100%, 97%, 1),\n    red-100: hsla(346, 76%, 90%, 1),\n    red-200: hsla(346, 83%, 84%, 1),\n    red-300: hsla(345, 75%, 64%, 1),\n    red-400: hsla(345, 75%, 55%, 1),\n    red-500: hsla(345, 68%, 43%, 1),\n    // yellow\n    yellow-50: hsla(48, 100%, 95%, 1),\n    yellow-100: hsla(48, 100%, 85%, 1),\n    yellow-200: hsla(47, 100%, 75%, 1),\n    yellow-300: hsla(43, 100%, 67%, 1),\n    yellow-400: hsla(46, 100%, 52%, 1),\n    yellow-500: hsla(43, 100%, 50%, 1),\n    // orange\n    orange-50: hsla(21, 100%, 96%, 1),\n    orange-100: hsla(21, 100%, 92%, 1),\n    orange-200: hsla(25, 100%, 81%, 1),\n    orange-300: hsla(29, 100%, 64%, 1),\n    orange-400: hsla(18, 100%, 63%, 1),\n    orange-500: hsla(12, 86%, 53%, 1),\n    // turquoise\n    turquoise-50: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-100: hsla(187, 100%, 95%, 1),\n    turquoise-200: hsla(188, 100%, 85%, 1),\n    turquoise-300: hsla(188, 82%, 71%, 1),\n    turquoise-400: hsla(188, 100%, 45%, 1),\n    turquoise-500: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-600: transparent, // TODO: update this value when it got defined on the designs\n    // violet\n    violet-50: hsla(250, 100%, 95%, 1),\n    violet-100: hsla(250, 100%, 91%, 1),\n    violet-200: hsla(250, 100%, 85%, 1),\n    violet-300: hsla(249, 68%, 74%, 1),\n    violet-400: hsla(249, 56%, 66%, 1),\n    violet-500: hsla(250, 52%, 58%, 1),\n    // snow\n    snow-50: hsla(0, 0%, 100%, 1),\n    snow-100: hsla(0, 0%, 97%, 1),\n    snow-200: hsla(0, 3%, 94%, 1),\n    snow-300: hsla(0, 0%, 90%, 1),\n    snow-400: hsla(0, 1%, 88%, 1),\n    snow-500: hsla(0, 0%, 81%, 1),\n);\n\n@function color($color) {\n    @return map.get($colors, $color);\n}\n\n@each $name, $color in $colors {\n    .color.#{$name} {\n        color: $color;\n    }\n}\n\n/* =============================================\n=              Background Colors              =\n============================================= */\n$background-colors: (\n    ocean: (\n        color: color(ocean-400),\n        contrast-color: color(snow-50),\n    ),\n    ocean-light: (\n        color: color(ocean-200),\n        contrast-color: color(snow-50),\n    ),\n    'green': (\n        color: color(green-400),\n        contrast-color: color(snow-50),\n    ),\n    green-light: (\n        color: color(green-200),\n        contrast-color: color(snow-50),\n    ),\n    'red': (\n        color: color(red-400),\n        contrast-color: color(snow-50),\n    ),\n    red-light: (\n        color: color(red-200),\n        contrast-color: color(snow-50),\n    ),\n    'orange': (\n        color: color(orange-400),\n        contrast-color: color(snow-50),\n    ),\n    orange-light: (\n        color: color(orange-200),\n        contrast-color: color(snow-50),\n    ),\n    space: (\n        color: color(space-400),\n        contrast-color: color(snow-50),\n    ),\n    space-light: (\n        color: color(space-200),\n        contrast-color: color(space-400),\n    ),\n    gray-light: (\n        color: color(snow-200),\n        contrast-color: color(space-400),\n    ),\n    'violet': (\n        color: color(violet-400),\n        contrast-color: color(snow-50),\n    ),\n    violet-light: (\n        color: color(violet-200),\n        contrast-color: color(space-400),\n    ),\n    'yellow': (\n        color: color(yellow-400),\n        contrast-color: color(snow-50),\n    ),\n    yellow-light: (\n        color: color(yellow-200),\n        contrast-color: color(space-400),\n    ),\n);\n\n@function get-background-color($color-name) {\n    @return map.get($background-colors, $color-name);\n}\n\n@mixin background-color($name) {\n    $colors: get-background-color($name);\n\n    background-color: map.get($colors, color);\n    color: map.get($colors, contrast-color);\n}\n\n@each $name in map-keys($background-colors) {\n    .background-color.#{$name} {\n        @include background-color($name);\n    }\n}\n","@use 'sass:color';\n@use '~$app-web/ui-kit/styles/theme';\n\n.root {\n    &.bottomMargin {\n        margin-bottom: theme.spacing(0.5);\n    }\n\n    .label {\n        @include theme.typo(body2);\n\n        color: theme.color(space-400);\n    }\n\n    &.groupLabel .label {\n        @include theme.typo(info1);\n\n        color: theme.color(gray-400);\n    }\n\n    .requiredIndicator {\n        @include theme.typo(info1);\n\n        color: theme.color(red-500);\n        margin-left: theme.spacing(0.25);\n    }\n\n    .labelHelperTextIcon {\n        margin-left: theme.spacing(0.25);\n    }\n\n    .labelWarningIcon {\n        margin-left: theme.spacing(0.25);\n    }\n\n    .tooltipTrigger {\n        align-items: center;\n        display: inline-flex;\n    }\n\n    &.disabled {\n        .label,\n        .requiredIndicator {\n            color: theme.color(space-200);\n        }\n    }\n}\n","@use 'sass:map';\n@use 'sass:string';\n\n$shadow-base-color: rgb(9, 30, 66);\n$second-shadow-color: rgba($shadow-base-color, 0.31);\n\n// TODO-MAYBE: Use our design system color palette colors.\n$box-shadows: (\n    sm: (0 1px 1px rgba($shadow-base-color, 0.25), 0 0 1px $second-shadow-color),\n    md: (0 3px 5px rgba($shadow-base-color, 0.2), 0 0 1px $second-shadow-color),\n    lg: (0 8px 12px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    xl: (0 18px 28px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    // TODO: These are not correct. They should be fixed when the values are fixed in Figma.\n    right: 0 0 20px rgba(73, 73, 73, 0.3),\n    left: 0 0 20px rgba(73, 73, 73, 0.3),\n);\n\n/* The \"blur\" parameter (the third one) for drop shadow is rendered twice as in the box shadow.\n * So we have to divide it by 2 to have the same output as box shadows.\n*/\n$drop-shadows: (\n    sm: (drop-shadow(0 1px 0.5px rgba($shadow-base-color, 0.25)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    md: (drop-shadow(0 3px 2.5px rgba($shadow-base-color, 0.2)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    lg: (drop-shadow(0 8px 6px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    xl: (drop-shadow(0 18px 14px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n);\n\n@function box-shadow($shadow: sm) {\n    @return map.get($box-shadows, $shadow);\n}\n\n@function drop-shadow($shadow: sm) {\n    @return map.get($drop-shadows, $shadow);\n}\n","@use 'sass:map';\n@use 'sass:math';\n@use 'misc' as *;\n\n$typography-html-font-size: 14px;\n$typography-font-size: 14px;\n$typography-font-family: 'Inter',\n    system-ui,\n    -apple-system,\n    'Segoe UI',\n    'Roboto',\n    'Noto Sans',\n    'Ubuntu',\n    'Cantarell',\n    'Helvetica Neue';\n\n$typography-font-weights: (\n    regular: 400,\n    medium: 500,\n    bold: 700\n);\n\n$typography-variants: (\n    h1: 24px medium 34px -0.47px,\n    h2: 20px medium 30px -0.33px,\n    h3: 20px regular 30px -0.33px,\n    h4: 16px bold 24px -0.18px,\n    h5: 16px medium 24px -0.18px,\n    body1: 14px bold 20px -0.09px,\n    body2: 14px medium 20px -0.09px,\n    body3: 14px regular 20px -0.09px,\n    info1: 12px bold 18px 0.01px,\n    info2: 12px medium 18px 0.01px,\n    info3: 12px regular 18px 0.01px,\n);\n\n@function font-weight($weight: regular) {\n    @return map.get($typography-font-weights, $weight);\n}\n\n@function px2rem($value) {\n    @return math.div($value, $typography-html-font-size) * math.div($typography-font-size, 14px) * 1rem;\n}\n\n@mixin typo-by-values($font-size, $font-weight, $line-height, $letter-spacing) {\n    @include font-weight($font-weight);\n\n    font-size: px2rem($font-size);\n    letter-spacing: $letter-spacing;\n    line-height: $line-height;\n}\n\n@mixin font-weight($weight: regular, $important: false) {\n    font-weight: font-weight($weight) if-important($important);\n}\n\n@mixin typo($variant) {\n    $variant-values: map.get($typography-variants, $variant);\n\n    @include typo-by-values($variant-values...);\n\n    // TODO: remove this (if it was redundant) after the new typography replaced the old one\n    font-family: $typography-font-family;\n}\n\n@mixin truncate() {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color": `styles_color__NDrnl`,
	"ocean-50": `styles_ocean-50__fVeRP`,
	"ocean-100": `styles_ocean-100__7ptY2`,
	"ocean-200": `styles_ocean-200__CvGIA`,
	"ocean-300": `styles_ocean-300__RJTNy`,
	"ocean-400": `styles_ocean-400__DrDHl`,
	"ocean-500": `styles_ocean-500__vCbJA`,
	"ocean-600": `styles_ocean-600__K3Csw`,
	"space-50": `styles_space-50__9KCPU`,
	"space-100": `styles_space-100__fnsmM`,
	"space-200": `styles_space-200__PKs9S`,
	"space-300": `styles_space-300__apiz8`,
	"space-400": `styles_space-400__oghQZ`,
	"space-500": `styles_space-500__+uZ6a`,
	"gray-50": `styles_gray-50__zctAd`,
	"gray-100": `styles_gray-100__1Vqwi`,
	"gray-200": `styles_gray-200__miF3H`,
	"gray-300": `styles_gray-300__hf2jp`,
	"gray-400": `styles_gray-400__Kg-sU`,
	"gray-500": `styles_gray-500__bKYAB`,
	"green-50": `styles_green-50__PbdvO`,
	"green-100": `styles_green-100__t-dAd`,
	"green-200": `styles_green-200__mvgEF`,
	"green-300": `styles_green-300__rgOnY`,
	"green-400": `styles_green-400__pzhkz`,
	"green-500": `styles_green-500__Brmx2`,
	"red-50": `styles_red-50__anrfa`,
	"red-100": `styles_red-100__7EjQ3`,
	"red-200": `styles_red-200__zXPi+`,
	"red-300": `styles_red-300__7GoGK`,
	"red-400": `styles_red-400__eVJLU`,
	"red-500": `styles_red-500__uwUqn`,
	"yellow-50": `styles_yellow-50__HoJL9`,
	"yellow-100": `styles_yellow-100__v-IxQ`,
	"yellow-200": `styles_yellow-200__2858K`,
	"yellow-300": `styles_yellow-300__xc6mZ`,
	"yellow-400": `styles_yellow-400__B1uhj`,
	"yellow-500": `styles_yellow-500__5pXfh`,
	"orange-50": `styles_orange-50__x-RWl`,
	"orange-100": `styles_orange-100__NHEcl`,
	"orange-200": `styles_orange-200__20EDO`,
	"orange-300": `styles_orange-300__f021S`,
	"orange-400": `styles_orange-400__rdRoP`,
	"orange-500": `styles_orange-500__Gu7uF`,
	"turquoise-50": `styles_turquoise-50__9-hYi`,
	"turquoise-100": `styles_turquoise-100__cjBVj`,
	"turquoise-200": `styles_turquoise-200__UsPQB`,
	"turquoise-300": `styles_turquoise-300__uNSHw`,
	"turquoise-400": `styles_turquoise-400__Za-DF`,
	"turquoise-500": `styles_turquoise-500__m6hS4`,
	"turquoise-600": `styles_turquoise-600__QF9KC`,
	"violet-50": `styles_violet-50__pS2AL`,
	"violet-100": `styles_violet-100__97WEC`,
	"violet-200": `styles_violet-200__crIE7`,
	"violet-300": `styles_violet-300__jvZfh`,
	"violet-400": `styles_violet-400__p5UaC`,
	"violet-500": `styles_violet-500__-UPUY`,
	"snow-50": `styles_snow-50__l8yqv`,
	"snow-100": `styles_snow-100__lsgow`,
	"snow-200": `styles_snow-200__o-TXD`,
	"snow-300": `styles_snow-300__EYSmK`,
	"snow-400": `styles_snow-400__qUCoZ`,
	"snow-500": `styles_snow-500__CocaK`,
	"background-color": `styles_background-color__xUwvO`,
	"ocean": `styles_ocean__UnyKs`,
	"ocean-light": `styles_ocean-light__dG3A0`,
	"green": `styles_green__poa1q`,
	"green-light": `styles_green-light__EXG1o`,
	"red": `styles_red__3swe9`,
	"red-light": `styles_red-light__iImC2`,
	"orange": `styles_orange__fpJEP`,
	"orange-light": `styles_orange-light__pGJGr`,
	"space": `styles_space__QesRK`,
	"space-light": `styles_space-light__c6PhC`,
	"gray-light": `styles_gray-light__wOWSp`,
	"violet": `styles_violet__Z2O65`,
	"violet-light": `styles_violet-light__qAXPM`,
	"yellow": `styles_yellow__KszBO`,
	"yellow-light": `styles_yellow-light__VA5Gv`,
	"root": `styles_root__FKzae`,
	"bottomMargin": `styles_bottomMargin__CkW7J`,
	"label": `styles_label__jX2Uh`,
	"groupLabel": `styles_groupLabel__CGHks`,
	"requiredIndicator": `styles_requiredIndicator__XY0jM`,
	"labelHelperTextIcon": `styles_labelHelperTextIcon__JYkff`,
	"labelWarningIcon": `styles_labelWarningIcon__LmhD8`,
	"tooltipTrigger": `styles_tooltipTrigger__VPA6I`,
	"disabled": `styles_disabled__xq3MG`
};
export default ___CSS_LOADER_EXPORT___;
